import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyContainer from "./component";
import { withRouter } from "react-router-dom";
import { getCombinedDiyDetails } from "./actions";
import { selectFlowOffline, setDiyDetails, setIsFetched } from "../post-inspection-diy/actions";
import { setPageLoading } from "../car-animation-loader/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        leadMonDetail,
        showLuxuryCar,
        isFetched,
        showSelfBought
    },
    repeatUserTransition: {
        pageLoading,
        loaderTitle
    }
}) => ({
    inspectionResponse,
    pageLoading,
    loaderTitle,
    leadMonDetail,
    showLuxuryCar,
    isFetched,
    showSelfBought
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getCombinedDiyDetailsConnect: getCombinedDiyDetails,
    setDiyDetailsConnect: setDiyDetails,
    setPageLoadingConnect: setPageLoading,
    selectFlowOfflineConnect: selectFlowOffline,
    setIsFetchedConnect: setIsFetched
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyContainer));
